<template>
  <div>
    <label
      :class="(negrita === 'true' ? 'font-weight-bold ' : '') + 'mb-1 w-100'"
      >{{ etiqueta }}</label
    >
    <div class="input-group">
      <b-form-input
        :type="tipoInput"
        :class="
          (grande === 'true' ? 'form-control-lg ' : '') + 'redondo-derecho'
        "
        :data-testid="dataTestid"
        :maxlength="maxlength"
        :state="estado"
        @change.native="change"
        @input.native="handler"
        @blur="blur"
        @keyup="keyup"
        trim
        autocomplete="off"
      ></b-form-input>
      <div class="d-flex align-items-stretch pl-1">
        <b-button
          :data-testid="'button-' + dataTestid"
          v-b-tooltip.hover
          title="Mostrar / Ocultar Contraseña"
          class="btn-azul-outline h-100 d-flex align-items-center"
          variant="outline-light"
          @click="mostrarcontrasena()"
        >
          <font-awesome-icon :icon="icono" class="m-0" />
        </b-button>
      </div>
      <b-form-invalid-feedback>{{ mensajeError }}</b-form-invalid-feedback>
    </div>
  </div>
</template>
<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEye, faPassport } from "@fortawesome/free-solid-svg-icons";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faEye);
library.add(faEyeSlash);
export default {
  props: [
    "etiqueta",
    "negrita",
    "grande",
    "dataTestid",
    "maxlength",
    "estado",
    "mensajeError"
  ],
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      tipoInput: "password",
      icono: "eye",
      mostrar: true
    };
  },
  methods: {
    mostrarcontrasena() {
      if (this.mostrar) {
        this.tipoInput = "text";
        this.icono = "eye-slash";
        this.mostrar = false;
      } else {
        this.tipoInput = "password";
        this.icono = "eye";
        this.mostrar = true;
      }
    },
    handler(evento) {
      this.$emit("input", evento.target.value);
    },
    change(evento) {
      this.$emit("change", evento);
    },
    blur(evento) {
      this.$emit("blur", evento);
    },
    keyup(evento) {
      this.$emit("keyup", evento);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/generales/inputs/InputPasswordWrapper.vue